import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { DashboardOutlined, PeopleOutline, ToggleOnOutlined, HistoryOutlined } from '@mui/icons-material';
import AdminOverview from './AdminOverview';
import AdminUsers from './AdminUsers';
import AdminModules from './AdminModules';
import AdminLog from './AdminLog';
import GuidedTour from '../../components/tour/GuidedTour';
import TourButton from '../../components/tour/TourButton';
import useTour from '../../components/tour/useTour';
import { TOURS } from '../../components/tour/tours';

const TABS = [
  { value: 'overview', label: 'Overview', icon: <DashboardOutlined fontSize="small" /> },
  { value: 'users', label: 'Users', icon: <PeopleOutline fontSize="small" /> },
  { value: 'modules', label: 'Modules', icon: <ToggleOnOutlined fontSize="small" /> },
  { value: 'log', label: 'Activity Log', icon: <HistoryOutlined fontSize="small" /> },
];

// /admin?tab=overview|users|modules|log (admins only: see AdminRoute)
const Admin = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = TABS.some(t => t.value === searchParams.get('tab')) ? searchParams.get('tab') : 'overview';
  const tour = useTour('admin');

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>Admin</Typography>
          <Typography variant="body2" color="text.secondary">Users, modules and activity across Mickles</Typography>
        </Box>
        <TourButton onClick={tour.start} />
      </Box>
      <Tabs
        value={tab}
        onChange={(e, value) => setSearchParams(value === 'overview' ? {} : { tab: value })}
        variant="scrollable"
        allowScrollButtonsMobile
        data-tour="admin-tabs"
        sx={{ mt: 1.5, mb: 2.5, borderBottom: 1, borderColor: 'divider' }}
      >
        {TABS.map(t => <Tab key={t.value} value={t.value} label={t.label} icon={t.icon} iconPosition="start" />)}
      </Tabs>
      {tab === 'overview' && <AdminOverview onOpenTab={(value) => setSearchParams({ tab: value })} />}
      {tab === 'users' && <AdminUsers />}
      {tab === 'modules' && <AdminModules />}
      {tab === 'log' && <AdminLog />}
      <GuidedTour steps={TOURS.admin} open={tour.open} onClose={tour.close} />
    </Box>
  );
};

export default Admin;
